// extracted by mini-css-extract-plugin
export var active = "_c0-7";
export var container = "_c0-0";
export var evenWidth = "_c0-4";
export var large = "_c0-5";
export var outlet = "_c0-8";
export var slide = "_c0-2";
export var small = "_c0-6";
export var tab = "_c0-3";
export var tabs = "_c0-1";